var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "none",
    d: "M6.30697 0.77198C6.12641 0.631549 5.87358 0.631549 5.69303 0.77198L0.44303 4.85531C0.321236 4.95004 0.25 5.09569 0.25 5.24999V11.6667C0.25 12.1087 0.425595 12.5326 0.738155 12.8452C1.05072 13.1577 1.47464 13.3333 1.91667 13.3333H4.24688C4.24792 13.3333 4.24896 13.3333 4.25 13.3333C4.25104 13.3333 4.25208 13.3333 4.25312 13.3333H7.74688C7.74792 13.3333 7.74896 13.3333 7.75 13.3333C7.75104 13.3333 7.75208 13.3333 7.75312 13.3333H10.0833C10.5254 13.3333 10.9493 13.1577 11.2618 12.8452C11.5744 12.5326 11.75 12.1087 11.75 11.6667V5.24999C11.75 5.09569 11.6788 4.95004 11.557 4.85531L6.30697 0.77198ZM8.25 12.3333H10.0833C10.2601 12.3333 10.4297 12.2631 10.5547 12.1381C10.6798 12.013 10.75 11.8435 10.75 11.6667V5.49453L6 1.80009L1.25 5.49453V11.6667C1.25 11.8435 1.32024 12.013 1.44526 12.1381C1.57029 12.2631 1.73986 12.3333 1.91667 12.3333H3.75V7C3.75 6.72386 3.97386 6.5 4.25 6.5H7.75C8.02614 6.5 8.25 6.72386 8.25 7V12.3333ZM4.75 12.3333H7.25V7.5H4.75V12.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarHome);
export default __webpack_public_path__ + "static/media/navbar-home.b51c1664.svg";
export { ForwardRef as ReactComponent };